import Component from './Component';
import Dropzone from 'dropzone';
import axios from 'axios';
import Questionnaire from './Questionnaire';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */
let newDropzone
let deletePromise;
let previewTemplate = `
    <div class="o-file-preview dz-file-preview">
        <div class="o-file-details dz-details">
            <div class="o-file-name dz-filename"><span data-dz-name></span></div>
            <div class="o-file-size">
                <span class="dz-size">
                    <span class="progress">0</span> MB of <span class="total"></span> MB
                </span>
                <!--<span style="display: none;" class="u-red" data-dz-errormessage></span>-->
                <div class="dz-error-message"><span data-dz-errormessage></span></div>
            </div>
            <div class="o-file-progress dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            <span class="o-file-preloader" data-dz-preloader>
                <img src="/img/preloader.gif">
            </span>
        </div>
    </div>
`;
let totalFileSize = 0;
let addedFile = 0;
let savedFiles = [];
const preloaderIcon = Dropzone.createElement(`<span class="o-file-preloader" data-dz-preloader><img src="/img/preloader.gif"></span>`);

const qs = window.Questions;




/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */

 function spliceArray (arr, id) {
    for (let i = 0 ; i < arr.length; i++) {
        if (arr[i].id == id) {
            arr.splice(i, 1);
            break;
        }
    }

    return arr;
}









/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class FileUpload extends Component {

    decorator () {
        return {
            selector : '.js-file-upload',
            name : 'FileUpload',
        }
    }


    constructor(element) {
        super(element);

        Dropzone.autoDiscover = false;

        // INITIAL CALLS
        this.cacheElements();

        this.bindElements();

        // const questionnaire = Questionnaire.prototype;
        this.questionnaire = this.element.parentElement.closest('.js-questionnaire').getElementsByTagName('fieldset');

    }


    cacheElements () {
        this.container = this.element.querySelector('.js-file-container');
        this.button = this.element.querySelector('.js-file-upload-btn');
        this._token = document.getElementsByName('_token');
        this.input = this.element.querySelector('input[type=hidden]');
        this.previewContainer = this.element.querySelector('.js-file-preview-container');
        this.preview = Array.from(this.previewContainer.querySelectorAll('.js-file-upload-preview'));
        this.maxFiles = this.element.getAttribute('data-upload-max');
        this.total = this.element.querySelector('.js-file-upload-total');
        let maxSize = this.element.getAttribute('data-upload-size');
        let URL = this.element.getAttribute('data-upload-url');
        let maxSizeInBytes = maxSize * 1024 * 1024;

        newDropzone = new Dropzone(this.container, {
            url: URL,
            clickable: this.button,
            directResponseError: 'Server not conifgured',
            createImageThumbnails: false,
            previewTemplate: previewTemplate,
            // uploadMultiple: this.maxFiles > 1 ? true : false,
            acceptedFiles: '.txt, .doc, .docx, .pdf',
            maxFiles: this.maxFiles,
            maxFilesize: maxSize,
            init: () => {

                savedFiles = this.input.value != '' ? JSON.parse(this.input.value) : [];
                addedFile = savedFiles != '' && savedFiles != [] ? JSON.parse(savedFiles).length : 0;

                let checkIfArray = !Array.isArray(savedFiles) ? JSON.parse(savedFiles) : savedFiles;

                if (checkIfArray.length < 0) { return; }

                for (let i = 0; i < checkIfArray.length; i++) {
                    totalFileSize += checkIfArray[i].size;
                }

                this.computeTotalSize(totalFileSize);
            }
        });



        newDropzone.on('error', (file, errorMessage) => {
            console.error(file, errorMessage);
            const self = newDropzone;
            const dzSize = file.previewElement.querySelector('.dz-size');
            const total = dzSize.querySelector('.total');
            const removeButton = Dropzone.createElement(`<a href="javascript:;" class="o-file-remove" data-dz-remove>
                <span class="o-icon"><svg><use xlink:href="#close"></use></svg></span>
            </a>`);

            dzSize.classList.add('u-red', 'u-ttu');

            if (file.size > maxSizeInBytes) {
                // add error if uploaded file is larger than ${maxSize}
                dzSize.innerHTML = `File is larger than ${maxSize} MB`;
            } else if (!file.accepted) {
                // if file is not accepted
                dzSize.innerHTML = `You can't upload files of this type`;
            }

            file.previewElement.querySelector('[data-dz-preloader]').remove();

            file.previewElement.appendChild(removeButton);

            removeButton.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();

                file.previewElement.classList.remove('is-added');

                addedFile--;

                this.maxLimit();

                setTimeout(() => {
                    self.removeFile(file);
                }, 500);
            });
        })


        // DROPZONE SENDING
        newDropzone.on('sending', (file, xhr, formData) => {
            formData.append('_token', this._token[0].value);
            formData.append('link', qs.link);
            formData.append('filename', file.upload.filename);
        });


        // DROPZONE ADDED FILE
        newDropzone.on('addedfile', file => {
            const self = newDropzone;
            const dzSize = file.previewElement.querySelector('.dz-size');
            const total = dzSize.querySelector('.total');

            total.innerHTML = (file.size / 1024 / 1024).toFixed(2);

            addedFile++;

            addedFile = addedFile > this.maxFiles ? this.maxFiles : addedFile;

            this.maxLimit();

            setTimeout(() => {
                file.previewElement.classList.add('is-added');
            }, 50);
        });


        // DROPZONE MAX FILES EXCEEDED
        newDropzone.on('maxfilesexceeded', file => {
            const self = newDropzone;

            self.removeFile(file);

            this.button.setAttribute('disabled', '');
        });


        // DROPZONE UPLOAD PROGRESS
        newDropzone.on('uploadprogress', (file, progress, byteSent) => {
            const dzSize = file.previewElement.querySelector('.dz-size');
            const prog = dzSize.querySelector('.progress');

            prog.innerHTML = (byteSent / 1024 / 1024).toFixed(2);
        });


        // DROPZONE SUCCESS
        newDropzone.on('success', (file, response) => {
            const self = newDropzone;
            const removeButton = Dropzone.createElement(`<a href="javascript:;" class="o-file-remove" data-dz-remove>
                <span class="o-icon"><svg><use xlink:href="#close"></use></svg></span>
            </a>`);
            const total = file.previewElement.parentElement.parentElement.parentElement.querySelector('.js-file-upload-total');
            const dzSize = file.previewElement.querySelector('.dz-size');
            // const responseID = response.id;
            let savedFile = {};

            file.previewElement.querySelector('[data-dz-preloader]').remove();
            file.previewElement.appendChild(removeButton);

            savedFiles = Array.isArray(savedFiles) ? savedFiles : JSON.parse(savedFiles);

            savedFile['id'] = response.id;
            savedFile['filename'] = file.name;
            savedFile['size'] = file.size;
            savedFile['path'] = response.path;

            savedFiles.push(savedFile);

            this.input.value = JSON.stringify(savedFiles);

            if (file.status == 'success') {
                dzSize.innerHTML = 'COMPLETE';
                totalFileSize += parseInt(file.size);
                this.computeTotalSize(totalFileSize);
            }

            removeButton.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();

                removeButton.remove();
                file.previewElement.appendChild(preloaderIcon);

                totalFileSize -= parseInt(file.size);

                savedFiles = spliceArray(savedFiles, response.id);

                let spliced = spliceArray(JSON.parse(this.input.value), response.id);
                this.input.value = '';
                this.input.value = spliced.length > 0 ? JSON.stringify(spliced) : [];

                const rData = {
                    id: response.id,
                    contents: qs,
                    isInit: true,
                    totalSize: totalFileSize
                }

                // remove file from db and
                this.removeFile(self, file, rData);

            });
        });
    }


    bindElements() {
        if (this.preview.length < 1) { return; }

        addedFile = this.preview.length;

        let newArr = JSON.parse(this.input.value);

        savedFiles = newArr;

        this.input.value = savedFiles;

        this.preview.forEach((item, idx) => {
            const removeButton = item.querySelector('.o-file-remove');
            const fileID = item.getAttribute('data-file-id');
            const size = item.getAttribute('data-file-size');

            removeButton.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();

                removeButton.remove();
                item.appendChild(preloaderIcon);

                let spliced = spliceArray(JSON.parse(this.input.value), fileID);
                this.input.value = '';
                this.input.value = spliced.length > 0 ? JSON.stringify(spliced) : [];

                totalFileSize -= parseInt(size);

                const rData = {
                    id: fileID,
                    contents: Questionnaire.prototype.appendAnswer(this.questionnaire),
                    isInit: false,
                    totalSize: totalFileSize
                }

                // remove file from db and storage
                this.removeFile(item, false, rData);
            })
        })
    }


    removeFile (elm, file, data = { id: 0, contents: {}, isInit: false, totalSize: 0 }) {
        deletePromise = axios.post(`/api/application/delete/${data.id}`, {
            link: qs.link,
            contents: JSON.stringify(data.contents)
        })
        .then(response => {
            if (data.isInit) {
                file.previewElement.classList.remove('is-added');
                setTimeout(() => {
                    elm.removeFile(file);
                    this.computeTotalSize(data.totalSize);
                }, 500);
            } else {
                elm.classList.remove('is-added')
                setTimeout(() => {
                    elm.remove();
                    this.computeTotalSize(data.totalSize);
                }, 500)
            }

            addedFile--;
            this.maxLimit();

            return;
        })
        .catch(error => {
            console.error(error);
        })
    }


    maxLimit () {
        if (addedFile >= parseInt(this.maxFiles)) {
            this.button.setAttribute('disabled', '')
        } else {
            this.button.removeAttribute('disabled')
        }
    }


    computeTotalSize (total) {
        this.total.innerHTML = (total / 1024 / 1024).toFixed(2);
    }

}
